// This is different than move_devices.js, called by show_move_devices_dialog controller
// That one doesn't require a devicegroup, this one does
import _ from 'underscore';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import AssignDevicesDialog from '@/views/dialogs/assign_devices';

    var globalCh = Radio.channel('global');
    var apiCh = Radio.channel('api');

    function show_view(devicegroup, data) {
        var devices = apiCh.request('device');
        var dc = new Backbone.Collection();
        data.forEach( (d) => {
            let device = apiCh.request(d.type, d.id);
            if (device === undefined) {
                device = devices.add(d);
            }
            if ( !device.rel.get('devicegroup') ) {
                dc.add(device);
            } else if ( device.rel.get('devicegroup').type
                        && device.rel.get('devicegroup').type.indexOf('dut') < 0 ) {
                dc.add(device);
            }
        });
        var dialog = new AssignDevicesDialog({
            collection: dc,
            devicegroup: devicegroup,
            filter: function(device) {
                return _.findWhere(data, { id : device.id });
            }
        });

        globalCh.request('showDialog', dialog);
    }

    function load_data() {
        var devices = apiCh.request('device');
        var active = globalCh.request('active_account');
        // Own unassigned devices
        return devices.fetch_all({
            remove: false,
            data: {
                'filter[account.id]': active.id,
                'filter[devicegroup.type]': 'neq:production_devicegroup,pre_production_devicegroup,pre_dut_devicegroup,dut_devicegroup'
            }
        });
    }

    function show_assign_devices_dialog(devicegroup) {
        load_data().then(function(data) {
            show_view( devicegroup, data );
        });
    }

    export default show_assign_devices_dialog;

